export default "__VITE_ASSET__BVOXOhkg__"